import { createFileRoute, Link } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { ChevronLeft } from 'lucide-react';
import { TestSession } from '../../features/test/test-session';

export const Route = createFileRoute('/_auth/test/$deckId')({
  component: TestDeckRoute,
  parseParams: (params) => ({ deckId: parseInt(params.deckId, 10) }),
  stringifyParams: (params) => ({ deckId: params.deckId.toString() }),
});

function TestDeckRoute() {
  const { t } = useTranslation();
  const { deckId } = Route.useParams();

  return (
    <div className="mx-auto max-w-5xl px-4 py-6 md:px-10 md:py-16">
      <Link
        to="/decks"
        className="mb-10 hidden md:inline-flex items-center gap-2 text-sm font-black uppercase tracking-[0.3em] text-[var(--color-text-muted)] transition-colors duration-500 hover:text-fuchsia-500"
      >
        <ChevronLeft size={12} />
        {t('decks.backToList')}
      </Link>

      <TestSession deckId={deckId} />
    </div>
  );
}
